import { memo } from 'react';

import AnthropicIconSVG from '@/assets/anthropic-filled-icon.svg?react';
import { Icon, IconProps } from '@/components/core';

const IAnthropicIcon = (props: Omit<IconProps, 'SVGComponent'>) => <Icon SVGComponent={AnthropicIconSVG} {...props} />;

export const AnthropicIcon = memo(IAnthropicIcon) as typeof IAnthropicIcon;
